import React, { Component } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default class SearchEnginesDialog extends Component {
    render(){
        const contentStyle = (this.props.pre) ? {whiteSpace:"pre"} : {}

		return (
			<Dialog
                classes={{ paper: "alertPaper" }}   
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                >
                <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" style={contentStyle}>
                        Show profile on search engines?<br/>
                        Get 300% more offers by showing your profile on search engines<br/>
                        Recruiters can find you on Google, Bing and other search engines
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} color="primary" aria-label="No">
                        No
                    </Button>
                    <Button onClick={this.props.enableSearchEngines} color="primary" variant="contained" aria-label="Yes, get more offers" autoFocus>
                        Yes, get more offers
                    </Button>
                </DialogActions>
            </Dialog>
		)
	}
}